// extracted by mini-css-extract-plugin
module.exports = {"content":"top-block_content__i3UOY","title":"top-block_title___DRGC"};